const style = `
  width: 100% !important;
  bottom: 0 !important;
  margin-bottom: 0 !important;
`

export default style
